var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template"},[(!_vm.isAppLoaded)?_c('Loader'):_c('transition',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }